<template lang="pug" src="./html/Labs.pug"></template>

<script>
  import ContentBase from '../ContentBase'

  export default {
    extends: ContentBase
  }
</script>

<style lang="sass" src="./style/Labs.sass"></style>
